import { gql } from "apollo-boost";
import { fragments } from "../queries/JobContracts";

export default gql`
  mutation UpdateContract($id: ID!, $input: ContractInput!) {
    updateContract(id: $id, input: $input) {
      ...JobContractsContract
    }
  }
  ${fragments.Contract}
`;



// WEBPACK FOOTER //
// ./src/mutations/UpdateContract.js